<template>
  <div class="partner box">
    <slider ref="slider" animation="fade" height="auto" :indicators="false" :control-btn="false" :interval="5000" :speed="1" v-on:change="onchange">
      <slider-item v-for="item in list" :key="item.id">
        <v-img ref="img" :src="item.image"/>
      </slider-item>
    </slider>
  </div>
</template>

<script>
  import {Slider, SliderItem} from 'vue-easy-slider'
  import helper from '../helper'

  export default {
    name: 'vPartner',
    props: {
      data: String
    },
    data() {
      return {
        list: []
      }
    },
    created() {
      helper.on(window, "resize", () => this.onchange());
      this.fetch()
    },
    components: {
      Slider, SliderItem
    },
    methods: {
      onchange() {
        const imgHeight = helper.height(_.get(this, "$refs.img.0.$el"));
        helper.height(this.$refs.slider.$el, imgHeight);
      },
      fetch() {
        return _.get(this, `$root.$data.${this.data}`).all()
          .filter(p => p.image)
          .then(papers => helper.push(this.list, papers))
          .delay(500)
          .then(() => this.onchange())
      }
    }
  }
</script>

<style scoped lang="stylus">
</style>